import request, { IWorkspaceResponse } from '../http/Xrequest '

// 分页查询图片文件夹 外部模型
export const getOutFolderPage = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/external-image/page'
  const result = await request.post(url, body)
  return result.data
}

// 获取图片文件夹下图片-分页 外部模型
export const getOutFilePage = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/external-image/images/page'
  const result = await request.post(url, body)
  return result.data
}

// 分页查询变化检测任务
export const getMontiorPage = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/business/media/change-task/page'
  const result = await request.post(url, body)
  return result.data
}

// 创建变化检测任务
export const getCreateMontior = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/business/media/change-task/create'
  const result = await request.post(url, body)
  return result.data
}

// 重试变化检测任务
export const resetMontiorTask = async function (taskId): Promise<IWorkspaceResponse<any>> {
  const url = `/business/media/change-task/retry/${taskId}`
  const result = await request.post(url)
  return result.data
}

// 带参数重试变化检测任务
export const resetParameterMontiorTask = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/business/media/change-task/retry-with-params'
  const result = await request.post(url, body)
  return result.data
}

// 查询变化检测任务历史记录
export const historyMontiorTask = async function (taskId): Promise<IWorkspaceResponse<any>> {
  const url = `/business/media/change-task/history/${taskId}`
  const result = await request.get(url)
  return result.data
}

// 检查是否存在相同参数的变化检测任务
export const checkSameMontiorTask = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/business/media/change-task/check-duplicate'
  const result = await request.post(url, body)
  return result.data
}

// 查询变化检测任务详情
export const montiorTaskData = async function (taskId): Promise<IWorkspaceResponse<any>> {
  const url = `/business/media/change-task/${taskId}`
  const result = await request.get(url)
  return result.data
}

// 根据objectKey获取文件访问地址
export async function getFileUrlByObjectKeyLong (objectKey: string) {
  const url = '/minio-file/get-url-by-object-key-long'
  const result = await request.get(url, { params: { objectKey } })
  return result.data
}

// 根据objectKey获取文件访问地址
export async function getFileUrlByObjectKeyLongZst (objectKey: string) {
  const url = '/minio-file/get-url-by-object-key-long-zst'
  const result = await request.get(url, { params: { objectKey } })
  return result.data
}

// 上传文件到 MinIO（返回 objectKey）
export async function uploadUavFile (params: FormData) {
  const url = '/minio-file/upload-file-uav'
  const result = await request.post(url, params)
  return result.data
}

// 更新文件是否在报告里显示
export const getWhetherUpdatedReport = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/files/update-file-in-report'
  const result = await request.post(url, body)
  return result.data
}

// 更新文件分析结果
export const updateFileAnalysisResult = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/files/update-file-analysis-result'
  const result = await request.post(url, body)
  return result.data
}

// 分页查询图片文件夹 隐患识别
export const getOutFolderLmPage = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/external-image-for-lm/page'
  const result = await request.post(url, body)
  return result.data
}

// 获取图片文件夹下图片-分页 隐患识别
export const getOutFolderLmFilePage = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/external-image-for-lm/images/page'
  const result = await request.post(url, body)
  return result.data
}

// 外部媒体大模型分析
export async function getModelOutFileAnalysisResult (file_id, portion, type) {
  const url = `/external-image/images/lm/${file_id}`
  const result = await request.get(url, { params: { portion, type } })
  return result.data
}

// 外部媒体AI分析
export async function getAiOutFileAnalysisResult (file_id, confidence: string) {
  const url = `/external-image/images/analysis/${file_id}`
  const result = await request.get(url, { params: { confidence } })
  return result.data
}

// 更新外部文件分析结果
export const updateOutFileAnalysisResult = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/external-image/update-file-analysis-result'
  const result = await request.post(url, body)
  return result.data
}
